// extracted by mini-css-extract-plugin
export default {"row":"ItemV3_row__UC-Ed","row_inner_wrapper":"ItemV3_row_inner_wrapper__jr-Ez","flex":"ItemV3_flex__vPnUV"};